/**
 * One line glyph per tile in the tray. A drawn part is recognised faster than
 * its name, and a biconvex outline beside a biconcave one says which is which
 * before either label is read.
 */
export type Glyph =
    | 'object' | 'pointSource' | 'parallelBeam' | 'rayBox'
    | 'planeMirror' | 'concaveMirror' | 'convexMirror'
    | 'convexLens' | 'concaveLens'
    | 'prism' | 'slab' | 'semicircle'
    | 'screen' | 'stop';

const PATHS: Record<Glyph, React.ReactNode> = {
    object: (
        <>
            <defs>
                <linearGradient id="ob-icon-rod" gradientUnits="userSpaceOnUse" x1="16" y1="27" x2="16" y2="6">
                    <stop offset="0" stopColor="#2c7fb8" /><stop offset="1" stopColor="#e67814" />
                </linearGradient>
            </defs>
            <line x1="16" y1="27" x2="16" y2="6" stroke="url(#ob-icon-rod)" strokeWidth="3.2" strokeLinecap="round" />
            <line x1="6" y1="27" x2="26" y2="27" />
        </>
    ),
    pointSource: (
        <>
            <circle cx="10" cy="16" r="3" fill="currentColor" />
            <path d="M14 16h13M13.5 12l12-5M13.5 20l12 5" />
        </>
    ),
    parallelBeam: <path d="M4 9h24M4 16h24M4 23h24M24 6l4 3-4 3M24 13l4 3-4 3M24 20l4 3-4 3" />,
    rayBox: (
        <>
            <rect x="3" y="11" width="11" height="10" rx="1.5" />
            <path d="M14 16h15" />
        </>
    ),
    planeMirror: <path d="M16 4v24M16 7l3-3M16 13l3-3M16 19l3-3M16 25l3-3" />,
    concaveMirror: <path d="M20 4Q10 16 20 28M20 4l3 1M19 10l3 1M18.5 16l3 0M19 22l3-1M20 28l3-1" />,
    convexMirror: <path d="M12 4Q22 16 12 28M12 4l-3 1M13 10l-3 1M13.5 16l-3 0M13 22l-3-1M12 28l-3-1" />,
    convexLens: <path d="M16 3Q24 16 16 29Q8 16 16 3Z" />,
    concaveLens: <path d="M11 3h10Q15 16 21 29H11Q17 16 11 3Z" />,
    prism: <path d="M16 4L28 27H4Z" />,
    slab: <rect x="5" y="10" width="22" height="12" rx="1" />,
    semicircle: <path d="M4 22h24A12 12 0 0 0 4 22Z" />,
    screen: <path d="M14 4h4v20h-4zM16 24v4M11 28h10" />,
    stop: <path d="M16 3v10M16 19v10M13 3h6M13 29h6" />,
};

export function PartIcon({ glyph }: { glyph: Glyph }): React.JSX.Element {
    return (
        <svg
            className="obench-icon" viewBox="0 0 32 32" width="32" height="32" aria-hidden="true"
            fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
        >
            {PATHS[glyph]}
        </svg>
    );
}
